import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiOutlinePlus } from "react-icons/hi2";
import { generatePath, Link } from "react-router-dom";

type CreateCampaignCardProps = {
  productId: string;
};

const CreateCampaignCard = ({ productId }: CreateCampaignCardProps) => {
  const { t } = useTranslation();
  return (
    <div className={"relative flex min-h-56 items-center justify-center rounded-lg border shadow-sm"}>
      <Link
        to={generatePath(routes.campaign.create, { productId })}
        className={
          "flex h-full w-full items-center justify-center text-sm font-medium text-quinary hover:text-quinary-hover"
        }
      >
        {t("predictive.campaign.createNew")} <HiOutlinePlus className={"size-5"} />
      </Link>
    </div>
  );
};

export default CreateCampaignCard;
